import * as React from "react";
import { Path, G, ClipPath, Defs, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const TJIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="TJ" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="M0 0h16v12H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#C51918"
        fillRule="evenodd"
        d="M0 0v4h16V0H0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#409100"
        fillRule="evenodd"
        d="M0 8v4h16V8H0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#FB0"
        d="M7.998 7.842c.661 0 1.247.07 1.757.207l-.092.328c-.478-.129-1.033-.194-1.665-.194-.631 0-1.186.065-1.664.194l-.093-.328c.51-.138 1.096-.207 1.757-.207Zm1.092-.43s.084.087.078.227l.202.084c-.003.004-.169.196-.37.162-.203-.034-.254-.27-.254-.27h.183c.004-.008.094-.172.16-.202Zm-2.215-.034c.068.032.162.205.162.205h.183c-.003.01-.056.234-.255.268-.2.034-.364-.156-.37-.162l.202-.083a.326.326 0 0 1 .078-.228Zm1.074-.069c.063.04.132.224.132.224l.18.025c-.003.01-.087.225-.288.23-.207.006-.344-.211-.344-.211l.212-.055a.323.323 0 0 1 .108-.213Zm-2.352-.946.36.007-.287.221.103.35-.294-.21-.296.21.104-.35L5 6.37l.36-.007.119-.346.118.346Zm5.028 0 .36.007-.287.221.105.35-.296-.21-.295.21.103-.35-.286-.221.36-.007.118-.346.118.346ZM5.908 5.17l.36.007-.287.222.105.35-.296-.21-.295.21.104-.35-.287-.222.36-.007.118-.345.118.345Zm4.336 0 .36.007-.287.222.104.35-.295-.21-.296.21.105-.35-.288-.222.36-.007.119-.345.118.345Zm-3.364-.92.36.008-.287.221.104.35-.295-.208-.296.209.104-.351-.287-.22.36-.009.119-.344.118.344Zm2.407 0 .36.008-.287.221.105.35-.296-.208-.296.209.105-.351-.288-.22.36-.009.119-.344.118.344Zm-1.16-.305.361.007-.287.221.105.35-.296-.21-.295.21.103-.35-.286-.221.36-.007.118-.346.118.346Z"
      />
      <Path
        fill="#FB0"
        d="M8.005 5.184c.56.038.506.648.504.662-.002-.006-.048-.11-.2-.11-.157 0-.248.156-.248.156v.6c0 .202.194.411.545.583.35.171.613-.172.613-.172s.14.329.494.418c.354.089.583-.115.583-.115s-.232.555-.67.416c-.433-.138-.463-.49-.463-.5-.007.012-.194.346-.557.305-.37-.041-.603-.578-.603-.578l-.012-.715-.012.715s-.234.537-.603.578c-.363.041-.55-.292-.557-.304 0 .01-.03.361-.463.499-.437.138-.668-.413-.67-.416.002.001.23.203.582.115.354-.09.494-.418.494-.418s.263.343.614.172c.35-.172.545-.381.545-.582v-.6s-.092-.157-.249-.157c-.151 0-.197.103-.2.11-.001-.014-.055-.624.503-.662v-.003l.016.001h.015v.002Zm-.03.167c-.261 0-.314.22-.314.22.23 0 .313.1.313.1a.782.782 0 0 1 .341-.1s-.08-.22-.34-.22Z"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
